import { cdoAbilityList, cdoBiome } from '../cdo/cdoTemplateCatalog.js';

const catalogConfig = (title, idField, client) => ({
  title: `${title} Editor`, copy: `Create and edit ${title.toLowerCase()} records. IDs are assigned automatically.`,
  listTitle: title, idField,
  emptyFactory: () => ({ [idField]: '', name: '', description: '', gmNotes: '' }),
  selectAll: client.selectAll, create: client.create, update: client.update, delete: client.delete,
  fields: [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea', columnWidth: 'minmax(240px, 2fr)' },
    { key: 'gmNotes', label: 'GM Notes', type: 'textarea', columnWidth: 'minmax(240px, 2fr)' },
  ],
  normalize: value => ({ ...value, name: value.name.trim() }),
  validate: value => !value.name ? 'Name is required.' : '',
});
export const templateReferenceConfigs = {
  AbilityList: catalogConfig('Ability List', 'idAbilityList', cdoAbilityList),
  Biome: catalogConfig('Biome', 'idBiome', cdoBiome),
};
